// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreArtistSection_container__HtgGN","title":"MoreArtistSection_title__fmi58"};